import SnackBar from './SnackBar.vue'

export { SnackBar }
export default SnackBar
